module.exports = __webpack_public_path__ + "static/media/Active users.8065e6fd.svg";